import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
   getActivities () {
     return Api().get("/activities");
  },
  updateActivity (params) {
    return Api().put("/activities",params);
  },
  addActivity (params) {
    return Api().post("/activities",params);
  },
  getActivity (params) {
    return Api().get("/activities/"+params);
  },
  deleteActivity (params) {
    return Api().delete("/activities/"+params);
  },
  findActivityExportProcess (params) {
    return Api().post("/find-activity-export-processes",params);
  },
  findActivityDateStatus (params) {
    return Api().post("/find-activity-date-status",params);
  },
  getActivitiesByCompany(params) {
    return Api().get("/activities-by-company-id/"+ params);
  },
}



// WEBPACK FOOTER //
// ./src/services/ActivityService.js